// extracted by mini-css-extract-plugin
module.exports = {"feature":"Feature_feature__2xrju","featureIcon":"Feature_featureIcon___7Mcy","featureText":"Feature_featureText__2ah3-","featureIconSize":"Feature_featureIconSize__1mUrG"};